export const getLeadEngagementHashTarget = (hash: string) => {
  if (hash.startsWith('#message-')) {
    return { messageId: hash.slice(1), tab: 'messages' as const };
  }

  return { messageId: undefined, tab: 'timeline' as const };
};
